export const ENDPOINTS = {
  purposes: 'options/data/purpose_of_payment',
  founds: 'options/data/source_of_founds',
};
